// extracted by mini-css-extract-plugin
export default {"vatDropdown":"ProductDialog--vatDropdown--a08533"};